import React from 'react';
import './SimpleSidebar.css';

const SimpleSidebar = ({ 
  isCollapsed, 
  onToggle, 
  logo, 
  menuItems, 
  switchProfile, 
  profileButton,
  profileName 
}) => {
  return (
    <div className={`simple-sidebar ${isCollapsed ? 'collapsed' : 'expanded'}`}>
      
      {/* Logo Container */}
      <div className="logo-container">
        <div className="simple-item simple-logo" onClick={onToggle}>
          <div className="simple-icon">
            <img src={logo.src} alt="" />
          </div>
          {!isCollapsed && (
            <div className="simple-label">
              {logo.expandIcon}
            </div>
          )}
        </div>
      </div>

      {/* Switch Profile */}
      <div className="simple-item" onClick={switchProfile?.onClick}>
        <div className="simple-icon photoswitch">
          {switchProfile?.avatar ? switchProfile.avatar : <div className="profile-avatar-skeleton"></div>}
        </div>
        {!isCollapsed && (
          <div className="simple-label">
            {switchProfile?.name ? switchProfile.name : <div className="profile-name-skeleton"></div>}
          </div>
        )}
      </div>
      
      {/* Menu Items */}
      <div className="simple-nav">
        {menuItems.map((item) => {
          if (item.isHeader) {
            return (
              <div key={item.id} className="simple-header">
                {!isCollapsed && (
                  <div className="simple-header-text">
                    {item.title}
                  </div>
                )}
              </div>
            );
          }
          
          return (
            <div
              key={item.id}
              onClick={() => item.onClick(item.id)}
              className={`simple-item ${item.active ? 'active' : ''}`}
            >
              <div className="simple-icon">
                {item.icon}
                {(item.badge > 0 && item.badge !== "New") && (
                  <span className="simple-badge">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              {!isCollapsed && (
                <div className="simple-label">
                  {item.title}
                  {item.badge === "New" && (
                    <span className="simple-badge-new">New</span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Gmail Profile - Bottom Left */}
      <div className="gmail-profile-section photogmail">
        {profileButton}
        {!isCollapsed && (
          <>
            <div className="gmail-profile-label">
              {profileName}
            </div>
            <p className="pro-plan-text">Pro plan</p>
          </>
        )}
      </div>
      
    </div>
  );
};

export default SimpleSidebar;